import React, {
  useState,
  useRef,
  useCallback,
  useEffect,
  Fragment,
  useContext,
  useMemo,
} from 'react';
import classNames from 'classnames';
import useOnClickOutside from '../../../hooks/useOnClickOutside';
import matchArrays from '../../../utils/matchArrays';
import getParamFilterValue from '../../../utils/getParamFilterValue';
import { Context } from '../../../context/AppContext';
import DropDown from './DropDown';
import NavButton from './NavButton';
import CheckBox from './CheckBox';
import ApplyButton from './ApplyButton';
import './styles.css';

const Services = ({
  fetchMore,
  filters,
  filter = '',
  selectedCount,
  defaultServices,
  updateDefaultServices,
  filtersCount,
  updateFiltersCount,
  sort,
}) => {
  const {
    media: { tablet, desktop },
  } = useContext(Context);
  const [selected, setSelected] = useState('');
  const [dirty, setDirty] = useState();
  const [dropdownFilters, setDropdownFilters] = useState([]);

  const [show, setShow] = useState();
  const ref = useRef();

  useEffect(() => {
    setSelected(filter);
    setDirty(false);
  }, [filter]);

  useEffect(() => {
    setDropdownFilters(filters);
  }, [filters]);

  useEffect(() => {
    if (
      filters &&
      !filters.length &&
      defaultServices &&
      defaultServices.length
    ) {
      setDropdownFilters(defaultServices);
    }
  }, [defaultServices, filters]);

  const matchInitial = useMemo(() => {
    return matchArrays(
      selected ? selected.split(',').sort() : [],
      filter ? filter.split(',').sort() : []
    );
  }, [selected, filter]);

  const setFilter = useCallback(
    (value, add) => {
      const paramFilter = getParamFilterValue(selected, value, add);
      setSelected(paramFilter);
      updateFiltersCount(paramFilter);
      setDirty(true);
    },
    [selected]
  );

  useOnClickOutside(
    ref,
    useCallback(() => {
      if (show) {
        setSelected(filter);
        updateFiltersCount(filter);
        setShow(false);
      }
    }, [filter, show])
  );

  const selectedValues = useMemo(
    () =>
      selected
        ? defaultServices.reduce((agg, { label, value }) => {
            if (selected.includes(value)) {
              return agg.concat(label);
            }
            return agg;
          }, [])
        : null,
    [selected]
  );

  return (
    <div
      className={classNames(
        'Listview__Filters__wrapper Listview__Filters__wrapper--scroll',
        {
          'Listview__Filters__wrapper--empty':
            !filter && !(filters || []).length,
        }
      )}
      ref={ref}
    >
      {tablet || desktop ? (
        <Fragment>
          <NavButton
            className="Listview__Filters__button--services"
            active={!!selectedCount || show}
            onClick={() => setShow(!show)}
            hasSelected={selectedCount}
          >
            Services
          </NavButton>
          <DropDown show={show} heading="Services">
            <div className="Listview__Filters__options">
              {show &&
                dropdownFilters &&
                !!dropdownFilters.length &&
                dropdownFilters.map(({ label, checked, value }) => (
                  <CheckBox
                    key={label}
                    defaultChecked={checked}
                    disabled={!filtersCount[value] && !checked}
                    value={value}
                    onClick={e => setFilter(e.target.value, e.target.checked)}
                  >
                    {label}{' '}
                    {filtersCount[value] > 0 ? `(${filtersCount[value]})` : ''}
                  </CheckBox>
                ))}
            </div>
            <ApplyButton
              active={dirty && !matchInitial}
              data-filter={selectedValues}
              onClick={e => {
                fetchMore(e, {
                  page: 0,
                  filter: selected,
                  sort,
                });
                updateDefaultServices(selected);
                setShow(false);
              }}
            >
              Apply
            </ApplyButton>
          </DropDown>
        </Fragment>
      ) : (
        <Fragment>
          {dropdownFilters.map(({ label, checked, value }) => (
            <Fragment key={label}>
              {checked ? (
                <NavButton
                  active={checked}
                  onClick={e => {
                    const paramFilter = getParamFilterValue(
                      selected,
                      value,
                      !checked
                    );
                    setSelected(paramFilter);
                    fetchMore(e, {
                      page: 0,
                      filter: paramFilter,
                      sort,
                    });
                  }}
                >
                  {label}{' '}
                  {filtersCount[value] > 0 ? `(${filtersCount[value]})` : ''}
                </NavButton>
              ) : (
                ''
              )}
            </Fragment>
          ))}
        </Fragment>
      )}
    </div>
  );
};

export default Services;
